module.exports = __webpack_public_path__ + "img/print-icon.48b39d2.svg";